import { effect, inject, Injectable } from '@angular/core';
import { NotificationData, NotificationService } from '@hypergraph/tapestry';
import { notificationQueue, queueActions } from './notification.store';
import { QueuedNotification } from './types';
import { NotificationComponent } from './notification/notification.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationDispatcherService {
  private readonly service = inject(NotificationService);

  constructor() {
    effect(() => {
      const pending = notificationQueue();

      if (pending.length > 0) {
        const next = pending[0];
        this.dispatch(next);
      }
    });
  }

  dispatch(notification: QueuedNotification) {
    const data: NotificationData = {
      id: notification.id,
      title: notification.data.title,
      message: notification.data.message ?? 'Action complete',
    };

    const config = {
      autoClose: true,
    };
    this.service.open(NotificationComponent, config, data);

    queueActions.dequeue();
  }
}
